export default {
  state: {
    dictionaries: []  //字典
  },
  getters: {
    dictionaries: state => state.dictionaries,
    comingWeeks: state => {
      return state.dictionaries
    },
    getDictionaryListByType: (state) => (type) => {
      return state.dictionaries.filter(dictionary => dictionary.type === type)
    }
  },
  mutations: {
    setDictionaries(state, dictionaries){  // 字典
      state.dictionaries = dictionaries;
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dictionary.js